<template>
        <div class="card border-0 m-b-10">
            <div class="card-body">
                <div class="card-text">
                    <ul class="media-list">
                        <li class="media media-sm" v-for="(item,index) in leadershipGet" :key="index">
                            <a class="media-left" href="javascript:;">
                                <img :src="item.image" alt="" class="media-object rounded-corner" />
                            </a>
                            <div class="media-body">
                                <h4 class="media-heading" v-text="item.name"></h4>
                                <p v-text="item['position_'+languageGet]"></p>
                                <div v-if="'children' in item">
                                    <div v-for="(childrenItem1,childrenIndex1) in item.children"
                                         class="media" :key="childrenIndex1" :class="{'media-sm': ('children' in childrenItem1)}">
                                        <a class="media-left" href="javascript:;">
                                            <img :src="childrenItem1.image" alt="" class="media-object rounded-corner" />
                                        </a>
                                        <div class="media-body">
                                            <h4 class="media-heading" v-text="childrenItem1.name"></h4>
                                            <p v-text="childrenItem1['position_'+languageGet]"></p>
                                            <div v-if="'children' in childrenItem1">
                                                <div v-for="(childrenItem2,childrenIndex2) in childrenItem1.children"
                                                     class="media" :key="childrenIndex2">
                                                    <a class="media-left" href="javascript:;">
                                                        <img :src="childrenItem2.image" alt="" class="media-object rounded-corner" />
                                                    </a>
                                                    <div class="media-body">
                                                        <h4 class="media-heading" v-text="childrenItem2.name"></h4>
                                                        <p v-text="childrenItem2['position_'+languageGet]"></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
</template>
<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: mapGetters(["languageGet","leadershipGet"]),
    }
</script>